export var COMSCORE_CMP = 77;
export var ADOBE_AUDIENCE_MANAGER_CMP = 565;
export var GOOGLE_CMP = 755;